import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'
import { getAwardDateFormatted } from '../DateSvc'

let awardYearCache = null

export function getServerTime() {
  return httpSvc.get(DS_ROUTES.time_current)
}

export async function getAwardYear() {
  return awardYearCache || fetchAwardYear()
}

export async function fetchAwardYear() {
  const resp = await httpSvc.get(DS_ROUTES.time_purple_ribbon_year)
  return awardYearCache = resp
}

export async function getAwardDate(dateType, format) {
  const awardDate = await getAwardYear()
  return getAwardDateFormatted(awardDate.data[`${dateType}_date`], format)
}
